import { Component } from 'react';
import worker from './worker';
import './index.css';
let w, a, b, c, d, e, f;

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      taskMin: 1,
      breakMin:1,
      taskName: "TASK",
      breakName: "BREAK",
      timerState: false,
      screenValue: "Pomodoro Clock",
      timerMin: 1,
      timerSec: 0,
      progressOne : 0,
      progressTwo : 0,
      switched : false
    }
    this.changeTaskName = this.changeTaskName.bind(this);
    this.changeBreakName = this.changeBreakName.bind(this);
    this.incTskMin = this.incTskMin.bind(this);
    this.decTskMin = this.decTskMin.bind(this);
    this.incBrkMin = this.incBrkMin.bind(this);
    this.decBrkMin = this.decBrkMin.bind(this);
    this.startTimer = this.startTimer.bind(this);
    this.reset = this.reset.bind(this);
  }

  componentDidMount() {
    this.setState({
      progressOne : 0,
      progressTwo : 0
    })
  }

  incTskMin() {
    if (this.state.timerState !== true) {
      if (this.state.taskMin === 60) {
        this.setState({
          taskMin: 60,
          timerMin : 60
        })
      } else {
        this.setState({
          taskMin: this.state.taskMin + 1,
          timerMin : this.state.timerMin + 1
        })
      }
    } 
  }

  decTskMin() {
    if (this.state.timerState !== true) {
      if (this.state.taskMin === 1) {
        this.setState({
          taskMin: 1,
          timerMin : 1
        })
      } else {
        this.setState({
          taskMin: this.state.taskMin - 1,
          timerMin : this.state.timerMin - 1
        })
      }
    }
  }

  incBrkMin() {
    if (this.state.timerState !== true) {
      if (this.state.breakMin === 60) {
        this.setState({
          breakMin: 60,
        })
      } else {
        this.setState({
          breakMin: this.state.breakMin + 1,
        })
      }
    }
  }

  decBrkMin() {
    if (this.state.timerState !== true) {
      if (this.state.breakMin === 1) {
        this.setState({
          breakMin: 1,
        })
      } else {
        this.setState({
          breakMin: this.state.breakMin - 1,
        })
      }
    }
  }

  changeTaskName(e) {
    this.setState({
      taskName: e.target.value
    })
  }

  changeBreakName(e) {
    this.setState({
      breakName: e.target.value
    })
  }


  startTimer() {
    const start_time = new Date();
    const expected_time = new Date(start_time.getTime() + (this.state.taskMin * 60000) + (this.state.breakMin * 60000));
    if (!this.state.timerState) {
      if (typeof(Worker) !== undefined) {
        if (typeof (w) === "undefined") {
          w = new Worker(worker);
          w.postMessage(!this.state.switched ? {
            timerMin : this.state.timerMin,
            timerSec : this.state.timerSec,
            breakMin : this.state.breakMin
          } : {
            timerMin : this.state.timerMin,
            timerSec : this.state.timerSec,
            breakMin : 0
          })
          w.onmessage = (e) => {
            let { timerMin, timerSec, playAudio, status } = e.data;
            let combined = (timerMin * 60) + timerSec;
            let beepBeep = document.getElementById("beep");          
            console.log(this.state.taskMin)  
            this.setState({
              progressOne : Math.round((100 - ((combined / ((this.state.switched ? this.state.breakMin : this.state.taskMin) * 60)) * 100))),
            })
            console.log(status)
            if (status === "STANDARD") {
              this.setState({
                timerMin : timerMin,
                timerSec : timerSec,
                taskMin : timerMin === 0 ? 1 : timerMin
              })
            } else if (status === "BREAK") {
              if (playAudio) {
                beepBeep.currentTime = 0;
                beepBeep.play();

                this.setState({
                  timerMin : timerMin,
                  timerSec : timerSec
                })

                this.setState({
                  screenValue : "Enjoy your long awaited break!",
                  switched : true
                }, () => {
                  e = setTimeout(() => {
                    this.setState({
                      screenValue: `[🛫:${start_time.toLocaleTimeString()}] [🛬:${expected_time.toLocaleTimeString()}]`
                    })
                  }, 2000)
                })
              }
            } else {
              if (playAudio) {
                beepBeep.currentTime = 0;
                beepBeep.play();
                w.terminate();
                w = undefined;
                this.setState({
                  screenValue : "Timer done.",
                  timerState : false,
                  timerMin : this.state.taskMin,
                  timerSec : 0,
                  progressOne : 0,
                  progressTwo: 0,
                  switched : false
                })
              }
            }
          }
          
          if (!this.state.switched) {
            this.setState({
              screenValue: "〵(^ o ^)〴",
              timerState: true
            }, () => {
              a = setTimeout(() => {
                this.setState({
                  screenValue: `Please do your task. Task name : ${this.state.taskName}`
                }, () => {
                  b = setTimeout(() => {
                    this.setState({
                      screenValue: `You'll have your break in ${this.state.timerMin} ${this.state.taskMin > 1 ? "mins" : "min"} ${this.state.timerSec} ${this.state.timerSec > 1 ? "secs" : "sec"}.`
                    }, () => {
                      c = setTimeout(() => {
                        this.setState({
                          screenValue: `[🛫:${start_time.toLocaleTimeString()}] [🛬:${expected_time.toLocaleTimeString()}]`
                        })
                      }, 2000)
                    })
                  }, 2000)
                })
              }, 2000)
            })
          } else {
            this.setState({
              screenValue : "Enjoy your long awaited break!",
              switched : true,
              timerState : true
            }, () => {
              f = setTimeout(() => {
                this.setState({
                  screenValue: `[🛫:${start_time.toLocaleTimeString()}] [🛬:${expected_time.toLocaleTimeString()}]`
                })
              }, 2000)
            })
          }
        }
      } else {
        this.setState({
          screenValue: "Sorry, your browser doesn't support background activity."
        }, () => {
          d = setTimeout(() => {
            this.setState({
              screenValue: "The timer won't start."
            })
          }, 2000)
        })
      }
    } else {
      w.terminate();
      w = undefined;
      clearTimeout(a);
      clearTimeout(b);
      clearTimeout(c);
      clearTimeout(d);
      clearTimeout(e);
      clearTimeout(f);
      this.setState({
        timerState : false,
        screenValue: "Timer paused!"
      })
    }

  }

  reset() {
    if (w === undefined) {
      w = undefined;
    } else {
      w.terminate();
      w = undefined;
    }
    clearTimeout(a);
    clearTimeout(b);
    clearTimeout(c);
    clearTimeout(d);
    clearTimeout(e);
    clearTimeout(f);
    this.setState({
      taskMin: 25,
      breakMin: 5,
      taskName: "TASK",
      breakName: "BREAK",
      timerState: false,
      screenValue: "Pomodoro Clock",
      timerMin: 25,
      timerSec: 0,
      progressOne : 0,
      progressTwo : 0,
      switched : false
    })
  }

  render() {
    return (
      <div className="main">
        <header className="main-header">
          <div className="container">
            <div className="header-text">
              <span></span><p>&nbsp;</p></div>
          </div>
        </header>
        <section className="main-clock-body">
          <div className="container">
            <section className="title">
              <div className="clock-title">
                <h1>Pomodoro Clock</h1>
                <span>2021 - charliecatxph</span>
              </div>
            </section>
            <section className="lcd-screen">
              <div className="main-lcd-screen">
                <span>{this.state.screenValue}</span>
              </div>
            </section>
            <section className="clock-settings">
              <div className="set-session-settings set-child" style={{ display: `${this.state.timerState ? "none" : "flex"}`}}>
                <div className="timer-title">
                  <h2>Task Duration</h2>
                </div>
                <div className="setting-buttons">
                  <i className="fas fa-arrow-circle-up" onClick={this.incTskMin}></i>
                  <span className="current-minutes">
                    {this.state.taskMin}
                  </span>
                  <i className="fas fa-arrow-circle-down" onClick={this.decTskMin}></i>
                </div>
                <div className="setting-info">
                  <em>*max : 60 minutes*</em>
                </div>
                <div className="setting-name-input">
                  <input
                    type="text"
                    placeholder="TASK NAME"
                    className="session-name"
                    value={this.state.taskName}
                    onChange={this.changeTaskName}
                  />
                </div>
              </div>
              <div className="main-timer set-child" style={{ width: `${this.state.timerState ? "100%" : "40%"}`}}>
                <div className="timer-title">
                  <h2>Timer</h2>
                </div>
                <div className="timer-body">
                  <span className="timer-time">
                    {this.state.timerMin < 10 ? "0" + this.state.timerMin : this.state.timerMin}:{this.state.timerSec < 10 ? "0" + this.state.timerSec : this.state.timerSec}
                  </span>
                </div>
                <div className="progress progress-bar-container">
                  <div className="progress-bar sesh-prog" role="progressbar" style={{ width: `${this.state.progressOne}%`, display: `${this.state.switched ? "none" : "block"}`}}>
                  {this.state.taskName}
                  </div>
                  <div className="progress-bar break-prog" role="progressbar" style={{ width: `${this.state.progressOne}%`, display: `${this.state.switched ? "block" : "none"}`}}>
                  {this.state.breakName}
                  </div>
                </div>
              </div>
              <div className="set-break-settings set-child" style={{ display: `${this.state.timerState ? "none" : "flex"}`}}>
                <div className="timer-title">
                  <h2>Break Duration</h2>
                </div>
                <div className="setting-buttons">
                  <i className="fas fa-arrow-circle-up" onClick={this.incBrkMin}></i>
                  <span className="current-minutes">
                    {this.state.breakMin}
                  </span>
                  <i className="fas fa-arrow-circle-down" onClick={this.decBrkMin}></i>
                </div>
                <div className="setting-info">
                  <em>*max : 60 minutes*</em>
                </div>
                <div className="setting-name-input">
                  <input
                    type="text"
                    placeholder="BREAK NAME"
                    className="break-name"
                    value={this.state.breakName}
                    onChange={this.changeBreakName}
                  />
                </div>
              </div>
            </section>
            <section className="start-pomodoro-timer">
              <div className="buttons">
                <button className={this.state.timerState ? "btn btn-warning" : "btn btn-success"} onClick={this.startTimer}>{this.state.timerState ? "Pause" : "Start"}</button>
                <button className="btn btn-danger" onClick={this.reset}>Reset</button>
              </div>
            </section>
          </div>
        </section>
        <audio
          src="https://raw.githubusercontent.com/freeCodeCamp/cdn/master/build/testable-projects-fcc/audio/BeepSound.wav"
          id="beep"
        ></audio>
      </div>
    );
  }
}

export default App;
